@let icon = markerIcon();
@let qualityStatus = correlationStateStatus();
@let isUnknownMarker = isUnknownMarkerIcon();

<svg-icon [src]="icon.src"
          [name]="icon.name ?? icon.src"
          [ngClass]="[
            'flex original-icon shrink-0',
            !isUnknownMarker && correlationType() !== CorrelationType.Pinpoint ? 'rotate-45' : '']"
          [svgClass]="[
            '!size-[' + size() + ']',
            qualityStatus === CommonStateStatus.Critical ? 'text-(--p-other-red-500)' : qualityStatus === CommonStateStatus.Warning ? 'text-(--p-orange-500)' : '']"></svg-icon>
